import type { BookedSalesSearch } from '@/lib/services/money/money.schema'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { bookedSalesSearchSchema } from '@/lib/services/money/money.schema'

export function redirectLegacyMoneySales({
  params,
  search,
}: {
  params: { orgId: number }
  search: BookedSalesSearch
}) {
  throw redirect({ to: '/$orgId/reports/sales-summary', params, search, replace: true })
}

export const legacyMoneySalesSearch = (search: unknown): BookedSalesSearch =>
  bookedSalesSearchSchema.parse(search)

export const Route = createFileRoute('/_authenticated/$orgId/money/sales/')({
  validateSearch: legacyMoneySalesSearch,
  beforeLoad: redirectLegacyMoneySales,
})
